/**
 * @generated SignedSource<<b3c51e12294dc9b89d6959541fefec18>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InstructorLessonTypeSelect_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly membershipType: {
        readonly id: string;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"LessonTypeSelect_session">;
  readonly " $fragmentType": "InstructorLessonTypeSelect_session";
};
export type InstructorLessonTypeSelect_session$key = {
  readonly " $data"?: InstructorLessonTypeSelect_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"InstructorLessonTypeSelect_session">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InstructorLessonTypeSelect_session",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LessonTypeSelect_session"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "membershipType",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};

(node as any).hash = "a9ad9e9d27a97f2b0c44db4ad58412fd";

export default node;
